
import Header from "../components/header";

export default function content() {
  return (
    <div className="relative flex flex-col px-8 py-8 text-2xl text-white leading-loose border bc-foreground w-full">
      <Header
        text={ "Contact Me"}>
      </Header>
      
      <p className='mt-6'>
        If you have any enquiries or questions, please feel free to contact me at:
      </p>
      <a className="font-bold text-xl mt-2 lg:text-2xl lg:mt-0 underline bc-foreground cl-foreground" href="mailto:mattdanielbarnett@gmail.com">
        mattdanielbarnett@gmail.com
      </a>

      <p className='mt-12'>
        For further info about me here:
      </p>
      <a className="font-bold underline bc-foreground cl-foreground" target="_blank" href="https://www.linkedin.com/in/matt-barnett-165812223/">
        My LinkedIn
      </a>
      <a className="font-bold underline bc-foreground cl-foreground" target="_blank" href="https://github.com/mattdbarnett">
        My GitHub
      </a>
    </div>
  )
}